import React, { useEffect, useState } from "react";
import DashboardHeader from "../Common/DashboardHeader";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  AcceptedData,
  AcceptedDataApi,
  ExportDataApi,
  MailSentApi,
  PendingData,
  PendingDataApi,
} from "../../services/redux/ApiActions";
import { setPendingData } from "../../services/redux/PendingReducer";
import { setMailSentData } from "../../services/redux/MailSentReducer";
import { setAcceptedData } from "../../services/redux/AcceptedReducer";
import { setFiltersData } from "../../services/redux/FilterReducer";

const Accepted = () => {
  const acceptedData = useSelector((state) => state.accepted.AcceptedData);
  const loginData = useSelector((state) => state.login.loginData);
  const savedfilterData = useSelector((state) => state.filterData.FiltersData);
  const [filterCustomerName, setFilterCustomerName] = useState("");
  const [filterCustomerPhone, setFilterCustomerPhone] = useState("");
  const [filterCustomerEmail, setFilterCustomerEmail] = useState("");
  const storedtotalRecords = localStorage.getItem("acceptedRecordsValue");

  const [currentPage, setCurrentPage] = useState(
    acceptedData?.pagedInfo?.pageNumber || 1,
  );

  const pageSize = 10;
  const totalRecords = acceptedData?.result.pagedInfo?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const displayedData = acceptedData?.result.value.slice(startIndex, endIndex);

  const getPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <li key={i} className={currentPage === i ? "active" : ""}>
          <a
            href="#"
            className="v2pPagination"
            rel="customerList"
            onClick={() => handlePageClick(i)}
          >
            {i}
          </a>
        </li>,
      );
    }
    return pageNumbers;
  };

  const handlePageClick = async (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getStartingSerialNumber = () => {
    // Calculate the starting serial number for the current page
    return (currentPage - 1) * pageSize + 1;
  };

  useEffect(() => {
    // console.log('mailSent', loginData)
    if (acceptedData) {
      AcceptedApi();
    }
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const AcceptedApi = async (event) => {
    const acceptedDataApiPayload = {
      filter: "",
      orderBy: "",
      pageSize: storedtotalRecords,
      pageNumber: 0,
    };
    const data = await dispatch(
      AcceptedDataApi(acceptedDataApiPayload, loginData.token_chr),
    );
    if (data) {
      dispatch(setAcceptedData(data));
    }
  };
  const handleChangeNameFilter = (e) => {
    setFilterCustomerName(e.target.value);
  };

  const handleChangePhoneFilter = (e) => {
    setFilterCustomerPhone(e.target.value);
  };
  const handleChangeEmailFilter = (e) => {
    setFilterCustomerEmail(e.target.value);
  };
  const ApplyFilter = async (event) => {
    event.preventDefault();
    const filterPayload = {
      filter:
        `${filterCustomerName !== "" ? `customerName@=${filterCustomerName},` : ""}${filterCustomerEmail !== "" ? `email@=${filterCustomerEmail},` : ""}${filterCustomerPhone !== "" ? `phone@=${filterCustomerPhone}` : ""}`.replace(
          /,\s*$/,
          "",
        ),
      orderBy: "",
      pageSize:
        acceptedData.result.pagedInfo.totalRecords === 0
          ? storedtotalRecords
          : acceptedData.result.pagedInfo.totalRecords,
      pageNumber: 1,
    };
    // console.log(filterPayload)
    const data = await dispatch(
      AcceptedDataApi(filterPayload, loginData.token_chr),
    );
    if (data) {
      dispatch(setAcceptedData(data));
      dispatch(setFiltersData(filterPayload));
    }
  };
  const PendingAPICall = async () => {
    const pendingDataPayload = {
      filter: "",
      orderBy: "",
      pageSize: 100,
      pageNumber: 1,
    };
    const pendindDataResponse = await dispatch(
      PendingDataApi(pendingDataPayload, loginData.token_chr),
    );
    if (pendindDataResponse) {
      dispatch(setPendingData(pendindDataResponse));
      dispatch(setFiltersData(""));
      localStorage.setItem(
        "pendingRecordsValue",
        pendindDataResponse.pagedInfo.totalRecords,
      );
      navigate("/pending");
    }
  };

  const MailSentCall = async () => {
    navigate("/mailSent");
    dispatch(setFiltersData(""));
  };

  const ClearFilter = async (event) => {
    event.preventDefault();
    setFilterCustomerName("");
    setFilterCustomerPhone("");
    setFilterCustomerEmail("");
    const filterPayload = {
      filter: ``,
      orderBy: "",
      pageSize: storedtotalRecords,
      pageNumber: 1,
    };
    // console.log(filterPayload)
    const data = await dispatch(
      PendingDataApi(filterPayload, loginData.token_chr),
    );
    if (data) {
      dispatch(setPendingData(data));
    }
  };
  const ExportData = async (event) => {
    event.preventDefault();
    const filterPayload = {
      filter: savedfilterData.filter,
      orderBy: "",
      type: "accepted",
    };
    // console.log(filterPayload)
    const data = await dispatch(
      ExportDataApi(filterPayload, loginData.token_chr),
    );
    if (data) {
      // console.log(data)
      // Decode base64 string to binary data
      const binaryData = atob(data.value);

      // Create a Blob from the binary data
      const arrayBuffer = new ArrayBuffer(binaryData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }

      const blob = new Blob([uint8Array], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Generate a random filename
      const randomFileName = `excel_file_${Date.now()}.xlsx`;

      // Create a download link
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = randomFileName;

      // Trigger a click event on the link to initiate the download
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      // dispatch(setMailSentData(data))
    }
  };

  return (
    <>
      <div className="logoBG">
        <div className="rightElement">
          <DashboardHeader />

          <div className="container v2pWrapper">
            <div className="row mt-2">
              <div className="col-md-6">
                <h1 className="onBoardTitle">Onboarding List</h1>
              </div>
              <div className="col-md-6 text-right">
                <a
                  href="#"
                  className="btn btn-default v2pAddBtn mt-1"
                  data-toggle="modal"
                  data-target="#myModal"
                >
                  Onboard new customer
                </a>
              </div>
            </div>

            <div className="row">
              <div className="msform col-md-12">
                <fieldset style={{ margin: 0, width: "100%" }}>
                  <ul className="v2ptabs">
                    <li>
                      <a onClick={MailSentCall} style={{ cursor: "pointer" }}>
                        Mail Sent
                      </a>
                    </li>
                    <li>
                      <a style={{ cursor: "pointer" }} onClick={PendingAPICall}>
                        Pending for Review
                      </a>
                    </li>
                    <li className="active">
                      <a style={{ cursor: "pointer" }}>Accepted</a>
                    </li>
                  </ul>
                  <div className="row">
                    <form onSubmit={ApplyFilter}>
                      <div
                        className="row mt-3"
                        style={{ position: " relative" }}
                      >
                        <div className="col-md-8">
                          <div className="col-md-4">
                            <label className="">Merchant</label>
                            <input
                              type="text"
                              name="customer"
                              onChange={handleChangeNameFilter}
                              value={filterCustomerName || ""}
                            />
                          </div>
                          <div className="col-md-4">
                            <label className="">Email</label>

                            <input
                              type="text"
                              name="email"
                              onChange={handleChangeEmailFilter}
                              value={filterCustomerEmail}
                            />
                          </div>
                          <div className="col-md-4">
                            <label className="">Phone</label>
                            <input
                              type="text"
                              name="phone"
                              onChange={handleChangePhoneFilter}
                              className="mobile"
                              value={filterCustomerPhone}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12 text-left">
                          <input
                            type="submit"
                            name="submit"
                            className="next action-button mt-3 btn btn-primary" // Added btn and btn-primary for styling
                            value="Filter list"
                          />
                          <div
                            onClick={ClearFilter}
                            className="action-button-previous mt-3 btn btn-secondary" // Added btn and btn-secondary for styling
                          >
                            Clear filter
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-12 text-right">
                      <a
                        onClick={ExportData}
                        className="v2pDownload btn btn-danger btn-sm"
                      >
                        Export Data
                      </a>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table
                      className="table table-bordered text-left"
                      id="customerList"
                    >
                      <thead>
                        <tr>
                          <th>Sr.No.</th>
                          <th>Merchant</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Partner Bank</th>
                          <th>Program</th>
                          <th>Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {displayedData?.map((item, index) => (
                          <tr key={index}>
                            <td>{getStartingSerialNumber() + index}</td>
                            <td>{item.customerName}</td>
                            <td>{item.email}</td>
                            <td>{item.phone}</td>
                            <td>{item.partnerBankName}</td>
                            <td>{item.program}</td>
                            <td>{item.isSubmitedAt}</td>
                            <td>
                              <button className="btn btn-info btn-info-v2p tp">
                                <Link to="/details">
                                  {" "}
                                  <i className="fa-regular fa-eye"></i> &nbsp;
                                  Details
                                </Link>
                              </button>
                              <a
                                href="javascript:void(0);"
                                onclick="openEditRMModal('SWZyOEpyQkxIcEhXUEFIbU8wY3BIUT09','Dummy Vendor','1','TestHDFCRM')"
                                className="btn btn-info btn-info-v2p tp"
                                title="Change RM"
                              >
                                <i className="fa-solid fa-gear"></i>
                              </a>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <nav id="PaginationV2p">
                    <ul className="pagination">
                      <li
                        className={`prev ${currentPage === 1 ? "disabled" : ""}`}
                      >
                        <a
                          href="#"
                          onClick={() => handlePageClick(currentPage - 1)}
                        >
                          &lt; previous
                        </a>
                      </li>
                      {getPageNumbers()}
                      <li
                        className={`next ${currentPage === totalPages ? "disabled" : ""}`}
                      >
                        <a
                          href="#"
                          onClick={() => handlePageClick(currentPage + 1)}
                          rel="customerList"
                          className="v2pPagination"
                        >
                          next &gt;
                        </a>
                      </li>
                    </ul>
                    <p>
                      Page {currentPage} of {totalPages}, Total Records{" "}
                      {acceptedData?.pagedInfo?.totalRecords || 0}
                    </p>
                  </nav>
                </fieldset>
              </div>
              <div className="col-md-12">
                <br />
                <br />
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Accepted;
